import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { IoCloseSharp } from "react-icons/io5";
import { toast } from "react-toastify";
import PasswordUpdate from "../component/PasswordUpdate";
import { useChangePasswordMutation } from "../store/api/authSlice";
import { capitalizeFirstLetter2 } from "../utils/dateAndTimeConversion";
import "./AddVehicle.scss";
import { useTranslation } from "react-i18next";

const initialState = {
  currentPassword: "",
  newPassword: "",
};

const Settings = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [changePassword, { isLoading }] = useChangePasswordMutation();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    setErrors((prev) => ({
      ...prev,
      [name]: value ? "" : `${t("errors." + name)} ${t("errors.required")}`,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    const passwordRegex =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,20}$/;

    // Required field validation
    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = `${t("errors." + key)} ${t("errors.required")}`;
      }
    });

    // Password format validation (only if present)
    if (
      formData.newPassword.trim() &&
      !passwordRegex.test(formData.newPassword.trim())
    ) {
      newErrors.newPassword = t("errors.passwordStrength");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    toast.dismiss();
    try {
      const response = await changePassword(formData).unwrap();
      if (response.statusCode === 200) {
        toast.success(response.message);
        setShow(true);
        setFormData(initialState);
      }
    } catch (err) {
      const mesg = err.data?.message || "Something went wrong";
      toast.error(mesg);
    }
  };

  return (
    <>
      <div className='outerBox'>
        <div className='dbSubHd mb-3'>
          {t("change")} {t("password")}
        </div>
        <div className='d-flex flex-wrap'>
          <div className='updatePW'>
            <ul className='form p-0'>
              <li>
                <input
                  type='password'
                  className='formInput'
                  placeholder={`${t("current")} ${t("password")}`}
                  name='currentPassword'
                  value={formData.currentPassword}
                  onChange={handleChange}
                />
                {errors.currentPassword && (
                  <span style={{ color: "red" }}>{errors.currentPassword}</span>
                )}
              </li>

              <li>
                <input
                  type='password'
                  className='formInput'
                  placeholder={`${t("new")} ${t("password")}`}
                  name='newPassword'
                  value={formData.newPassword}
                  onChange={handleChange}
                />
                {errors.newPassword && (
                  <span style={{ color: "red" }}>{errors.newPassword}</span>
                )}
              </li>
              {/* <li>
                    <input
                      type="password"
                      className="formInput"
                      placeholder="Confirm Password"
                      name="cpassword"
                      value={cpassword}
                      onChange={handleChange}
                    />
                    <span style={{ color: "red" }}>
                      {errors && errors.cpasswordError}
                    </span>
                  </li> */}
            </ul>
          </div>
          <div className='PWHint ms-sm-4 ms-0 mt-sm-0 mt-4'>
            <span className='mb-2 d-block'>
              {t("password")} {t("must")} {t("be")}/{t("include")}:
            </span>
            <ul className='m-0 p-0'>
              <li>
                {t("between")} 8 {t("And")} 20 {t("Characters")}
              </li>
              <li>
                {t("an")} {t("uppercase")} {t("character")}
              </li>
              <li>
                {t("_a")} {t("lowercase")} {t("character")}
              </li>
              <li>
                {t("_a")} {t("Number")}
              </li>
              <li>
                {t("_a")} {t("special")} {t("character")}
              </li>
            </ul>
          </div>
        </div>
        <div className='pt-4'>
          <Button
            className='smallBtn auto'
            onClick={handleSubmit}
            disabled={isLoading}>
            {isLoading ? (
              <div
                className='spinner-border'
                role='status'>
                <span className='sr-only p-0'></span>
              </div>
            ) : (
              t("btns.submit")
            )}
          </Button>
        </div>
      </div>

      <Modal show={show}>
        <Button
          className='closePopup'
          onClick={handleClose}>
          <IoCloseSharp />
        </Button>
        <PasswordUpdate onClose={handleClose} />
      </Modal>
    </>
  );
};
export default Settings;
